import { Item } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './dropdown.scss';

type Props = ComponentPropsWithoutRef<typeof Item> & {
    inset?: boolean;
    selected?: boolean;
};
export const DropdownItem = ({ className, inset, selected, ...props }: Props) => {
    return (
        <Item
            data-testid="dropdown-menu-item"
            data-inset={inset}
            data-selected={selected}
            className={cn(
                'dropdown__item',
                inset && 'dropdown__item--inset',
                selected && 'dropdown__item--selected',
                className,
            )}
            {...props}
        />
    );
};
